/**
 * Cashflow logo.
 *
 * Uses the user-provided icon PNG (transparent bg). Two variants:
 *   • cashflow-mark.png       — navy ₹ + gold staircase (default, for light bg)
 *   • cashflow-mark-light.png — white ₹ + gold staircase (for dark bg)
 *
 * Wordmark is rendered in Space Grotesk text so we control weight, tracking,
 * and color — never baked into the image.
 */

const MARK = "/brand/cashflow-mark.png";
const MARK_LIGHT = "/brand/cashflow-mark-light.png";

export function CashflowMark({ size = 40, className = "", variant = "dark" }) {
  const src = variant === "light" ? MARK_LIGHT : MARK;
  return (
    <img
      src={src}
      alt="Cashflow"
      width={size}
      height={size}
      className={className}
      style={{
        width: size,
        height: size,
        objectFit: "contain",
        display: "block",
        // The source mark has a wider footprint than tall — a small correction
        // keeps it visually balanced next to text at any size.
      }}
    />
  );
}

/**
 * Full lockup: icon + "Cashflow" wordmark side-by-side.
 * `variant="light"` swaps mark + wordmark to white for dark backgrounds.
 */
export function CashflowLockup({ size = 32, className = "", variant = "dark" }) {
  const light = variant === "light";
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <CashflowMark size={size} variant={variant} />
      <span
        className="font-display tracking-tight"
        style={{
          fontWeight: 700,
          fontSize: Math.round(size * 0.66),
          lineHeight: 1,
          letterSpacing: "-0.02em",
          color: light ? "#FFFFFF" : "#123159",
        }}
      >
        Cashflow
      </span>
    </div>
  );
}
